module.exports = __webpack_public_path__ + "media/common/images/cta/iwan-671ddf42fe48ba6db7ae9cec58d26ac6.jpeg";